export default __webpack_public_path__ + "static/media/13.285b6eec.jpg";